import React from "react";
import Lottie from "lottie-react-web";
import animation from "../../assets/grapes.json";
import styles from "./splashScreen.module.css";

const index = () => (
  <div className={styles.loader}>
    <Lottie
      options={{
        animationData: animation,
      }}
      width="25%"
      height="25%"
    />
    {/* <p>Easy Trading</p> */}
  </div>
);

export default index;
